<template>
  <div>
    <div class="b-template-container">
      <div class="b-template-nav__logo" @click="handleClickLogo">
        <img src="https://assets.kuvera.in/production/atlantis/web/assets/img/kuvera-logo-dark.svg" />
      </div>
      <div class="b-template-nav__middle-heading">
        <h3>Kuvera Backend Ops</h3>
      </div>
      <div class="b-template-nav__right-heading">
        <div v-if="admin" class="b-template-nav_show-right-heading">
          <div class="b-template-nav__user-detail">{{admin.name}} &#8226;</div>
          <div class="b-template-nav__logout" @click="logout">Log out</div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { mapState, mapGetters } from "vuex";
export default {
  mounted() {
    // this.$store.commit('set_admin_partner', this.$route.params.partner)
    if (Vue.vueAuth.isAuthenticated()){
      this.fetchAdminInfo(this.$router); 
    }
    else {
      this.$router.push({ name: 'kyc-login', params: {partner: this.admin_partner}});
    }
  },

  methods: {
    ...mapActions(["adminLogout", "fetchAdminInfo"]),
    logout: function() {
      this.adminLogout().then(() => this.$router.push("/"));
    },
    handleClickLogo(){
       this.$router.push({ name: 'kyc-details', params: {status: 'Pending', partner: this.admin_partner}});
      // this.$router.push('/kyc-details/Pending');
       this.$store.commit("resetTab");
    }
  },
  computed: mapState({ 
    admin: state => state.kycLogin.admin,
    admin_partner: state => state.kycLogin.admin_partner,
    kyc_verification_type: state => state.kycLogin.kyc_verification_type}),
};
</script>
<style scoped>
.b-template-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 51px;
  position: fixed;
  width: 100vw;
  left: 0;
  top: 0;
  border-bottom: 1px solid #e6e6e6;
  background-color: aliceblue;
  z-index: 2;
}
.b-template-nav__right-heading {
  display: flex;
  justify-content: end;
  margin-right: 25px;
}
.b-template-nav_show-right-heading {
  display: flex;
}
.b-template-nav__logo {
  margin-left: 25px;
  cursor: pointer;
}
.b-template-nav__logout {
  cursor: pointer;
  margin-right: 10px;
}
.b-template-nav__user-detail {
  margin-right: 10px;
}
</style>